/**
 * Rutas de la consola de administracion.
 */

export const routes = {
  home: '/',
  login: '/login',
  authCallback: '/auth/callback',
  applications: '/applications',
  roles: '/roles',
  users: '/users',
  notFound: '/404',
} as const;

export type RouteKey = keyof typeof routes;
